<template>
  <div class="page">
    <AssistantMode v-if="mode !== 'review'" @exit="goBack" @review="openReview" />

    <DraftReview
      v-else
      :draft="draft"
      @back="mode = ''"
      @confirm="onConfirmed"
      @cancel="goBack"
    />
  </div>
</template>

<script>
import DraftReview from "@/components/addInventory/DraftReview.vue";
import AssistantMode from "@/components/addInventory/AssistantMode.vue";

export default {
  name: "AddInventoryWizard",
  components: { DraftReview, AssistantMode },

  data() {
    return {
      mode: "",
      draft: null,
    };
  },

  methods: {
    openReview(draft) {
      const normalized = { ...(draft || {}) };

      if (!normalized.acquisition_summary) {
        normalized.acquisition_summary = {
          source: "",
          date: "",
          entry_method: "assistant",
          total_cost: null,
          card_type: "",
        };
      }

      normalized.acquisition_summary.card_type = normalized.acquisition_summary.card_type || "";


      if (!Array.isArray(normalized.items)) normalized.items = [];

      this.draft = normalized;
      this.mode = "review";
    },

    onConfirmed(result) {
      console.log("✅ acquisition confirmed:", result);
      alert("Inventory added!");
      this.goBack();
    },

    goBack() {
      this.$router.push({ name: "AddInventory" });
    },
  },
};
</script>

<style scoped>
.page {
  /* keep the wizard truly edge-to-edge */
  min-height: 100vh;
}
</style>
